export enum UserTypeEnum {
  test,
  official,
}

export const USER_DATA_LIST: SelectOption[] = [
  { label: '正式数据', value: UserTypeEnum.official },
  { label: '测试数据', value: UserTypeEnum.test },
];
